'use strict'

import format from 'string-format'

import {ModelBase} from './base'

class ProbePlexProbe extends ModelBase {

	constructor(probePlex, data, rootState) {
		super(data)

		this.probePlex = probePlex
		this.probe = rootState.lists.probes[data.probe_id]

		// в data.wells есть список идентификаторов лунок для зонда,
		// но очень не хочется их (подробности) загружать в SPA
	}
}

class ProbePlex extends ModelBase {
	constructor(data, rootState) {
		super(data)

		const me = this


		//
		// this.projects = Object.assign({}, ...(data.projects).map(
		// 	(p) => rootState.lists.projects[p.id]
		// ))

		let k = 15

		this.probe_list = Array.from(data.probe_list,
			(ppp) => new ProbePlexProbe(me, ppp, rootState))

		this.probes = Object.assign({}, ...(this.probe_list).map(
			(ppp) => ({[ppp.id]: ppp})))

		// this.project_list = Array.from(data.projects,
		// 	(pr) => rootState.lists.projects[pr.id])

		// замена id проектов на объекты мешает работать
		// с проектами набора зондов способом, аналогичным Plate, Sample
		// this.projects = Object.assign({}, ...(data.projects).map(
		// 	(pr_id) => ({[pr_id]: rootState.lists.projects[pr_id]})))

		let k2 = 11
	}
}

export {ProbePlex, ProbePlexProbe}